import Farmer from "../components/configuration/famer/Farmer";

const FarmerPage = () =>{

    return(
        <Farmer/>
    )
}

export default FarmerPage;
